import React from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import Button from '@material-ui/core/Button';
import LeftArrowIcon from 'Icons/LeftArrowIcon';
import bemit from 'Functions/bemit';
export default function BookingPreviousStep({
  ...props
}) {
  const have_services = BookingFormStore.useState(s => s.have_services);
  const step = BookingFormStore.useState(s => s.step);
  const is__visible = step === 1 && have_services;
  if (!is__visible) return null;
  return /*#__PURE__*/React.createElement(Button, {
    type: "button",
    onClick: props.goBack,
    className: bemit('c-arrow-btn', ['primary']) + ' booking-go-back'
  }, /*#__PURE__*/React.createElement(LeftArrowIcon, {
    className: "c-arrow-btn__arrow"
  }), /*#__PURE__*/React.createElement("span", {
    className: "c-arrow-btn__text"
  }, "Retour \xE0 l'\xE9tape pr\xE9c\xE9dente"));
}
